export default function MapLocationCard({
  storeData,
  openExtendedCard,
  getDirections,
}: any) {
  return (
    storeData &&
    storeData.length > 0 &&
    storeData.map((element: any, index: any) => {
      const bgImage = element?.company_logo?.data?.attributes?.url
        ? `${element?.company_logo?.data?.attributes?.url}`
        : "/images/location-cardbg.png";
      return (
        <div
          className="card-item"
          key={index}
          onClick={() => openExtendedCard(element)}
        >
          <div
            className="left-section-card"
            style={{
              backgroundImage: `url(${bgImage})`,
            }}
          ></div>
          <div className="right-section-card">
            <h3>{element.company_name}</h3>
            {/* <p>Wine store | 1 km</p> */}
            {/* <div className="close-text-wrapper">
                  <span>Closed. </span>
                  <span>Opens Mon-Sat,</span>
                  <span> 9.00am - 7.00am</span>
                </div> */}
            <p>{element.address_line_1 + element.address_line_2}</p>
            <div className="direction-wrapper">
              <ul>
                <li
                  onClick={(e) => {
                    e.stopPropagation();
                    getDirections(element);
                  }}
                >
                  <img src="/svg/direction.svg" />
                  Directions
                </li>
                {element.phone_number && (
                  <li>
                    <a
                      href={`tel:${element.phone_number}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="/svg/phone.svg" />
                      Call
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      );
    })
  );
}
